import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { screenings } from "@/mocks/screenings";
import type { Screening } from "@/types/content";

export default function ScreeningPreview() {
  const today = "2026-10-13";
  const todayList = (screenings as Screening[]).filter((item) => item.date === today);

  return (
    <section className="max-w-content mx-auto px-4 md:px-8 py-16 md:py-20">
      <div className="flex items-end justify-between gap-4 mb-10">
        <div>
          <p className="text-xs font-label tracking-widest text-accent-500 uppercase mb-3">Today</p>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">放映动态</h2>
          <p className="text-sm text-foreground-600 mt-3">10 月 13 日今日场次预览</p>
        </div>
        <Link
          to="/screenings"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看全部放映
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      {todayList.length === 0 ? (
        <div className="rounded-lg border border-background-200/70 bg-background-100 p-10 text-center">
          <i className="ri-calendar-close-line text-3xl text-foreground-500" />
          <p className="text-sm text-foreground-600 mt-3">今天暂无放映场次</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {todayList.map((item, i) => (
            <Reveal key={item.id} delay={i * 70}>
              <Link
                to={`/films/${item.filmId}`}
                className="group flex items-center gap-5 p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-accent-500/60 transition-colors cursor-pointer"
              >
                <div className="flex flex-col items-center justify-center w-20 h-20 rounded-lg bg-accent-500/10 shrink-0">
                  <span className="font-heading font-bold text-xl text-accent-500">{item.time}</span>
                  <span className="text-[11px] text-foreground-500 font-label mt-0.5">开始</span>
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="font-heading font-semibold text-foreground-950 truncate group-hover:text-accent-500 transition-colors">
                    {item.filmTitle}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-building-2-line" />
                      {item.hall}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-cpu-line" />
                      {item.tech}
                    </span>
                  </p>
                </div>
                <span className="font-heading font-semibold text-accent-500 whitespace-nowrap">¥{item.price}</span>
              </Link>
            </Reveal>
          ))}
        </div>
      )}
    </section>
  );
}